import React from "react";
import { Route, Switch } from "react-router-dom";

import Login from "../screens/Login";

const Routes = () =>
    <Switch>
        <Route exact path={"/"} render={(props) => <Login {...props}/> }/>
    </Switch>

export default Routes;